import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  hidden: {
    display: 'none',
  },
}))

export default useStyles
